import { AbstractControl, ValidatorFn } from '@angular/forms';
export default class PasswordValidation {

    static MatchPassword(): ValidatorFn {
        return (controls: AbstractControl) => {
            const password = controls.get('password');
            const confirmPassword = controls.get('confirmPassword');

            if (confirmPassword?.errors && !confirmPassword.errors['matching']) {
                return null;
            }
            if (password?.value !== confirmPassword?.value) {
                controls.get('confirmPassword')?.setErrors({ matching: true });
                return { matching: true };
            } else {
                return null;
            }
        }
    }
}